import './App.css';
import {make as MainView} from "./MainView.bs";

function App() {
  return <MainView/>
}

export default App;
